import TaoConsole from './TaoConsole';

/* eslint-disable camelcase */

const CookieJar = {};

/**
 * local Utility Functions
 */
CookieJar.get_cookies = function() {
	const cookies = document.cookie.split( ';' );
	const cm = {};
	let cookie, name, value, c;
	for ( c in cookies ) {
		if ( cookies.hasOwnProperty( c ) ) {
			cookie = cookies[ c ].split( '=' );

			name = CookieJar.maybe_trim( cookie[ 0 ] );
			value = CookieJar.maybe_trim( cookie[ 1 ] );

			cm[ name ] = value;
		}
	}
	return cm;
};

CookieJar.get_cookie = function( name ) {
	const cookies = CookieJar.get_cookies();
	const cookie = cookies[ name ] || undefined;

	TaoConsole.log( 'GET COOKIE', cookie );
	return cookie;
};

CookieJar.set_cookie = function( name, value, ms = {} ) {
	let options = {
		'path': '/',
	};

	if ( 'number' === typeof ms ) {
		const date = new Date();
		date.setTime( date.getTime() + ms );

		options = {
			expires: date.toGMTString(),
			...options,
		};
	} else if ( 'object' === typeof ms ) {
		options = {
			...options,
			...ms,
		};
	}

	const cookie = {
		[ name ]: value,
		...options,
	};

	const strCookie = Object.keys( cookie ).map( ( cooKey ) => {
		const cooVal = cookie[ cooKey ];
		return cooKey + '=' + cooVal;
	} ).join( '; ' );

	TaoConsole.log( 'SET COOKIE', strCookie );
	document.cookie = strCookie + ';' + ' Secure;';
};

CookieJar.getPageDelay = function() {
	if ( 'sessionStorage' in window ) {
		return parseInt( window.sessionStorage.getItem( 'pdl' ) || 0 );
	}

	return parseInt( CookieJar.get_cookie( 'pdl' ) || 0 );
};

CookieJar.incrementPageDelay = function() {
	let counter = CookieJar.getPageDelay();

	if ( ! counter ) {
		counter = 0;
	}

	// Update Pagecounter ( Session Cookie ).
	counter = parseInt( counter ) + 1;

	if ( 'sessionStorage' in window ) {
		return window.sessionStorage.setItem( 'pdl', String( counter ) );
	}
	return CookieJar.set_cookie( 'pdl', counter, { secure: true } );
};

CookieJar.maybe_trim = function( str ) {
	if ( 'string' !== typeof str ) {
		return str;
	}

	if ( 'function' === typeof str.trim ) {
		return str.trim();
	}
	return str;
};

window.TaoCookieJar = CookieJar;
export default CookieJar;
